import styled from "@emotion/styled"

export const StyledBetaTesters = styled.div`
  .content-stack {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .section-card {
    border-radius: 14px;
  }

  .section-title {
    margin: 0 0 8px;
    font-size: 18px;
    font-weight: 700;
  }

  .section-subtitle {
    margin: 0 0 16px;
    color: var(--cms-text-secondary);
    font-size: 14px;
    line-height: 1.45;
  }

  .form-grid {
    display: grid;
    grid-template-columns: minmax(220px, 1fr) minmax(160px, 220px) auto;
    gap: 12px;
    align-items: flex-start;
    margin-bottom: 12px;
  }

  .filters {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    align-items: center;
    margin-bottom: 16px;
  }

  .lookup-result {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-top: 8px;
    padding: 12px 14px;
    border-radius: 10px;
    border: 1px solid var(--cms-border);
    background: var(--cms-surface-muted);
  }

  .lookup-meta {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .lookup-meta strong {
    font-size: 14px;
    color: var(--cms-text-primary);
  }

  .lookup-meta span {
    font-size: 13px;
    color: var(--cms-text-secondary);
  }

  .row-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    flex-wrap: wrap;
  }

  .table-empty,
  .page-empty {
    color: var(--cms-text-secondary);
    padding: 24px;
    text-align: center;
  }

  .search-result-info {
    margin-bottom: 10px;
    font-size: 13px;
    color: var(--cms-text-secondary);
  }

  .pagination-section {
    display: flex;
    justify-content: center;
    padding: 12px 0;
  }
`
